export class ExpertProcessingStatus {
    constructor(processingStatus) {
        this.processingStatus = processingStatus

        this.isValid = ExpertProcessingStatus.checkIfValid(processingStatus)

        if (!this.isValid) {
            throw new Error(`Not a valid processingStatus: '${processingStatus}'!`)
        }
    }

    static checkIfValid(processingStatus) {
        processingStatus = processingStatus.trim()

        if (!processingStatus) {
            return false
        }

        return this.listOfValidProcessingStatuses.includes(processingStatus)

    }

    static listOfValidProcessingStatuses = [
        'processing',
        'completed',
        'cancelled',
        'error'
    ]

    static Processing = Object.freeze(new this('processing'))
    static Completed = Object.freeze(new this('completed'))
    static Cancelled = Object.freeze(new this('cancelled'))
    static Error = Object.freeze(new this('error'))
}